import { defineComponent as _defineComponent } from 'vue'
import DialogWrapperDesktop from '@ve/components/dialogWrapper/desktop/DialogWrapperDesktop.vue';
    import {
        Ref, ref, unref, onMounted, getCurrentInstance,
        computed,
    } from 'vue';
    import getPageType from "@fr/src/js/common/Domain/Service/getPageType";

    interface IProps {
        imageLink: string,
        adLabel?: string,
        coupon?: string | null,
        end?: string,
        start?: string,
        title: string,
        text: string,
        link: {
            behaviour: typeof LINK_BEHAVIOURS[number],
            text: string,
            value: string
        },
        button: {
            behaviour: typeof BUTTON_BEHAVIOURS[number],
            text: string,
            value: string
        },
        preventLocalStorage: boolean,
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdModal',
  props: {
    imageLink: null,
    adLabel: null,
    coupon: null,
    end: null,
    start: null,
    title: null,
    text: null,
    link: null,
    button: null,
    preventLocalStorage: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({(event: 'click', value: HTMLElement): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        imageLink: string,
        adLabel?: string,
        coupon?: string | null,
        end?: string,
        start?: string,
        title: string,
        text: string,
        link: {
            behaviour: typeof LINK_BEHAVIOURS[number],
            text: string,
            value: string
        },
        button: {
            behaviour: typeof BUTTON_BEHAVIOURS[number],
            text: string,
            value: string
        },
        preventLocalStorage: boolean,
    };

    const BEHAVIOURS = {
        OPEN_NEW_PAGE: 'openNewPage',
        OPEN_THIS_PAGE: 'openThisPage',
        COPY: 'copy',
        CLOSE: 'close',
    } as const;

    const BUTTON_BEHAVIOURS = [
        BEHAVIOURS.OPEN_NEW_PAGE,
        BEHAVIOURS.OPEN_THIS_PAGE,
        BEHAVIOURS.COPY,
        BEHAVIOURS.CLOSE,
    ] as const;

    const LINK_BEHAVIOURS = [
        BEHAVIOURS.OPEN_NEW_PAGE,
        BEHAVIOURS.OPEN_THIS_PAGE,
        BEHAVIOURS.COPY,
    ] as const;

    

    const proxy = getCurrentInstance()?.proxy;

    

    const popupWrapperRef: Ref<InstanceType<typeof DialogWrapperDesktop> | null> = ref(null);

    const isCopied: Ref<boolean> = ref(false);

    const showTooltipRef: Ref<boolean> = ref(false);

    const linkTarget = computed(() => (props.link.behaviour === BEHAVIOURS.OPEN_NEW_PAGE ? '_blank' : '_self'));

    const adModalRef = ref<HTMLDivElement | null>(null);

    const handleLinkClick = (event: MouseEvent) => {
        const { behaviour, value } = props.link;

        if (behaviour === 'copy') {
            event.preventDefault();
            const target = event.currentTarget as HTMLElement;
            if (target && window.copyPromo) {
                window.copyPromo(target);
            }
        } else if (behaviour === 'openThisPage') {
            event.preventDefault();
            window.location.href = value;
        }

        if (adModalRef.value && window.sendPromoClick) {
            window.sendPromoClick(
                adModalRef.value,
                behaviour,
                'link'
            );
        }
    };

    const btnClickHandler = (event: MouseEvent) => {
        const { behaviour, value } = props.button;

        if (!BUTTON_BEHAVIOURS.includes(behaviour)) {
            console.warn('Invalid button behaviour:', behaviour);
            return;
        }

        switch (behaviour) {
            case BEHAVIOURS.COPY: {
                const button = event.currentTarget as HTMLElement;
                if (button && window.copyPromo) {
                    window.copyPromo(button);
                    isCopied.value = true;
                    setTimeout(() => {
                        isCopied.value = false;
                    }, 5000);
                }
                break;
            }
            case BEHAVIOURS.CLOSE:
                unref(popupWrapperRef)?.clickCloseBtn(event,'Button_close');
                break;
            case BEHAVIOURS.OPEN_THIS_PAGE:
                window.location.href = value;
                break;
            case BEHAVIOURS.OPEN_NEW_PAGE:
                window.open(value, '_blank');
                break;
            default:
                console.warn(`Unhandled button behaviour: ${behaviour}`);
                break;
        }

        if (behaviour !== BEHAVIOURS.CLOSE && adModalRef.value && window.sendPromoClick) {
            window.sendPromoClick(
                adModalRef.value,
                behaviour,
                'button'
            );
        }
    };

    const open = () => {
        unref(popupWrapperRef)?.open();
    };

    onMounted(() => {
        open();
        if (adModalRef.value && window.sendPromoView) {
            window.sendPromoView(adModalRef.value);
        }
        if (!props.preventLocalStorage) localStorage.setItem('adModalLastViewDate', new Date().toISOString());
    });

    if (proxy) {
        (proxy as any).open = open;
    }

return { __sfc: true,BEHAVIOURS, BUTTON_BEHAVIOURS, LINK_BEHAVIOURS, props, proxy, emit, popupWrapperRef, isCopied, showTooltipRef, linkTarget, adModalRef, handleLinkClick, btnClickHandler, open, DialogWrapperDesktop, getPageType }
}

})